import { render, staticRenderFns } from "./GenerarReporte.vue?vue&type=template&id=2d5760ee&"
import script from "./GenerarReporte.vue?vue&type=script&lang=js&"
export * from "./GenerarReporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports